import { useEffect, useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { isValidDate } from "../../../../../CommonFunction/CheckDateIsInvalidOrNot";
import { convertToISO } from "../../../../../CommonFunction/DateConvertToISO";
import { OnlyToShowDate } from "../../../../../CommonFunction/IsoDateTime";
import Button from "../../../Button/Button";
import Input from "../../../Input/Input";
import "./SearchBoxesDiv.scss";

function SearchBoxesDiv({ isShowFromDateSearch = true }) {
  const dispatch = useDispatch();
  const location = useLocation();

  let DateData = useSelector((store) => store?.financialYear);
  // console.log(DateData);
  let Date = DateData?.selectedFinancialYears;
  let SelectedDate = DateData?.SelectedDate;

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  //default financial year show in from date, to date, redux and headers
  useEffect(() => {
    const storedYear = sessionStorage.getItem("SelectedFinancialYear");
    const selectDateFetch = () => {
      if (storedYear && !location.pathname.includes("Account_Vouchers")) {
        const yearObj = JSON.parse(storedYear);
        dispatch({
          type: "SET_SELECTED_DATE",
          payload: { FromDate: yearObj?.fromDate, ToDate: yearObj?.toDate },
        });
        if (yearObj?.fromDate) {
          sessionStorage.setItem("SelectedFromDate", JSON.stringify(yearObj?.fromDate));
        }
        sessionStorage.setItem("SelectedToDate", JSON.stringify(yearObj?.toDate));
      }
      if (!location.pathname.includes("Account_Vouchers")) {
        dispatch({
          type: "SET_SELECTED_DATE_FOR_VOUCHER",
          payload: { FromDate: "", ToDate: "" },
        });
      }
    };

    selectDateFetch();
  }, [Date]);

  useEffect(() => {
    if (SelectedDate.FromDate && SelectedDate?.ToDate) {
      // console.log(SelectedDate, OnlyToShowDate(SelectedDate?.FromDate), OnlyToShowDate(SelectedDate?.ToDate));
      setFromDate(OnlyToShowDate(SelectedDate?.FromDate));
      setToDate(OnlyToShowDate(SelectedDate?.ToDate));
    }
  }, [SelectedDate]);

  const handleFromDateChange = (e) => {
    const dateString = e.target.value;
    setFromDate(dateString);
    const date = isValidDate(dateString);
    if (date) {
      dispatch({
        type: "SET_SELECTED_DATE",
        payload: { FromDate: convertToISO(dateString) },
      });
      if (dateString) {
        sessionStorage.setItem("SelectedFromDate", JSON.stringify(convertToISO(dateString)));
      }
    }
  };

  const handleToDateChange = (e) => {
    const dateString = e.target.value;
    setToDate(dateString);
    const date = isValidDate(dateString);
    if (date) {
      dispatch({
        type: "SET_SELECTED_DATE",
        payload: { ToDate: convertToISO(dateString) },
      });
      if (dateString) {
        sessionStorage.setItem("SelectedToDate", JSON.stringify(convertToISO(dateString)));
      }
    }
  };

  const RefetchOnGo = () => {
    dispatch({ type: "Refetch", payload: true });
  };

  return (
    <div className="searchboxes_div">
      <div className="from_to_div">
        {isShowFromDateSearch && (
          <div style={{ display: "flex", width: "150px" }}>
            <Input
              EMTQuery=""
              checked={""}
              InputConfig={{ restrictDateRange: true, Reference_field: "financialYear", headerDate: true }}
              name="From"
              value={fromDate}
              type="Date"
              className="dateinput"
              handleInputChange={handleFromDateChange}
              handleBlur={(e) => {}}
            />
          </div>
        )}
        <div style={{ display: "flex", width: "150px" }}>
          <Input
            EMTQuery=""
            checked={""}
            InputConfig={{ restrictDateRange: true, Reference_field: "financialYear", headerDate: true }}
            name="To"
            value={toDate}
            type="Date"
            className="dateinput"
            handleInputChange={handleToDateChange}
            handleBlur={(e) => {}}
          />
        </div>

        <Button type="submit" name="gobutton" text="GO" action={RefetchOnGo} />
      </div>
      <div className="serach_div">
        <HiDotsVertical className="threedots" />
      </div>
    </div>
  );
}

export default SearchBoxesDiv;
